import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const trailImage = css`
  block-size: ${spacing(3)};
`
